import { extractStringValueSet } from './extract-properties';

export default class OrderIntent {

    static readonly Clinical: string = 'clinical';
    static readonly ResearchProspective: string = 'research-prospective';
    static readonly ResearchRetrospective: string = 'research-retrospective';
    static readonly RAD: string = 'rad';
    static readonly DataBackfill: string = 'data-backfill';
    static readonly EnhancedTherapiesMatch: string = 'enhanced-therapies-match';
    static readonly ResearchBiobanking: string = 'research-biobanking';

    /**
   * @deprecated in favor of either ResearchProspective or ResearchRestrospective
   */
    static readonly Research: string = 'research';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {

        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
